// Static map for Tailwind class names so they are detected by JIT.
export const COLOR_MAP = {
  blue: { badge: "bg-blue-100 text-blue-800 border-blue-300", dot: "bg-blue-500", hex: "#3b82f6" },
  orange: { badge: "bg-orange-100 text-orange-800 border-orange-300", dot: "bg-orange-500", hex: "#f97316" },
  cyan: { badge: "bg-cyan-100 text-cyan-800 border-cyan-300", dot: "bg-cyan-500", hex: "#06b6d4" },
  emerald: { badge: "bg-emerald-100 text-emerald-800 border-emerald-300", dot: "bg-emerald-500", hex: "#10b981" },
  violet: { badge: "bg-violet-100 text-violet-800 border-violet-300", dot: "bg-violet-500", hex: "#8b5cf6" },
  pink: { badge: "bg-pink-100 text-pink-800 border-pink-300", dot: "bg-pink-500", hex: "#ec4899" },
  amber: { badge: "bg-amber-100 text-amber-800 border-amber-300", dot: "bg-amber-500", hex: "#f59e0b" },
  slate: { badge: "bg-slate-100 text-slate-800 border-slate-300", dot: "bg-slate-500", hex: "#64748b" },
  red: { badge: "bg-red-100 text-red-800 border-red-300", dot: "bg-red-500", hex: "#ef4444" },
  lime: { badge: "bg-lime-100 text-lime-800 border-lime-300", dot: "bg-lime-500", hex: "#84cc16" },
  indigo: { badge: "bg-indigo-100 text-indigo-800 border-indigo-300", dot: "bg-indigo-500", hex: "#6366f1" },
  rose: { badge: "bg-rose-100 text-rose-800 border-rose-300", dot: "bg-rose-500", hex: "#f43f5e" },
};

export const PALETTE = ["blue", "orange", "cyan", "emerald", "violet", "pink", "amber", "slate", "red", "lime", "indigo", "rose"];

export const colorOf = (key) => COLOR_MAP[key] || COLOR_MAP.slate;
